import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { LocalService} from '../services/local.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, public route: Location, private localService: LocalService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      var isLoggedin = (this.localService.getJsonValue('isLoggedin') ? true : false);
      if (isLoggedin) {
        console.log("true");
        
        return true;
      } else {
        console.log("false");
        this.router.navigate(['/login']);
        return false;
      }
  }
}
